import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Header } from "../components/header";
import { Navbar } from "../components/navbar";
import { PromoBanner } from "@/components/promo-banner";
import { ReviewBanner } from "@/components/review-banner";
import { WalkthroughBanner } from "@/components/walkthrough-banner";
import { BlackFridayBanner } from "@/components/black-friday-banner";
import { ConsultationBanner } from "@/components/consultation-banner";
import { Toaster } from "sonner";

export const Route = createRootRoute({
  component: () => (
    <>
      <div className="cy:min-h-screen">
        <BlackFridayBanner />
        <Header />
        <Navbar />
        <div className="cy:max-w-full cy:mx-auto  cy:py-8 cy:relative cy:pl-2 cy:bg-[#E9EEF4]">
          <Toaster 
            position="top-right"
            expand={true}
            closeButton
            toastOptions={{
              style: {
                maxWidth: '100%',
                width: '100%',
                margin: '0 0 16px 0',
                borderRadius: '4px',
                padding: '12px 16px',
                borderLeft: '4px solid #22c55e',
                backgroundColor: '#f0fdf4',
                color: '#166534',
              },
              className: 'cy:shadow-sm',
            }}
          />
          <div className="cy:max-w-7xl cy:mx-auto">
            {/* Walkthrough Banner - Full Width */}
            <WalkthroughBanner />
            
            {/* Review Banner - Full Width */}
            <ReviewBanner />

            {/* Consultation Banner - Full Width */}
            <ConsultationBanner />

            {/* Main Grid Layout */}
            <div className="cy:grid cy:grid-cols-12 cy:gap-4">
              <div className="cy:col-span-9">
                <Outlet />
              </div>
              <div className="cy:col-span-3">
                <PromoBanner />
              </div>
            </div>
          </div>
        </div>
        <TanStackRouterDevtools />
      </div>
    </>
  ),
});
